export function organizationDashboardFilters(organizationDomainToken) {
  if (!organizationDomainToken) {
    return {};
  }

  return {
    customSubdomain: [organizationDomainToken],
    CustomDomainToken: [organizationDomainToken],
  };
}
